import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import DropdownController from "./controllers/dropdown_controller"
import IntakeFormController from "./controllers/intake_form_controller"
import MessageOrderingController from "./controllers/message_ordering_controller"
import MobileMenuController from "./controllers/mobile_menu_controller"
import FaqAccordionController from "./controllers/faq_accordion_controller"
import AddRecommendationController from "./controllers/add_recommendation_controller"
import ModalController from "./controllers/modal_controller"
import TabsController from "./controllers/tabs_controller"

const application = Application.start()
application.register("add-recommendation", AddRecommendationController)
application.register("dropdown", DropdownController)
application.register("intake-form", IntakeFormController)
application.register("message-ordering", MessageOrderingController)
application.register("mobile-menu", MobileMenuController)
application.register("faq-accordion", FaqAccordionController)
application.register("modal", ModalController)
application.register("tabs", TabsController)